import React from "react";
import { Button, CardHeader, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import InviteCodeModal from "./modals/InviteCodeModal";
import { PopoverBody, UncontrolledPopover } from "reactstrap";
import { DASHBOARD_USER_ROLES } from "../../../constants";
const NavProfile = ({
  activeTab,
  tabChange,
  currentUser,
  onInviteCode,
  openModalInviteCode,
  setOpenModalInviteCode,
  isUserInvited,
}) => {
  const inviteCode = currentUser?.inviteCode;

  const isBroker = currentUser?.role === DASHBOARD_USER_ROLES.BROKER;

  const [isCodeCopied, setIsCodeCopied] = React.useState(false);
  const handleOpenModalInviteCode = () => {
    setOpenModalInviteCode(true);
  };

  const handleCopyInviteCode = () => {
    setIsCodeCopied(true);
    navigator.clipboard.writeText(currentUser.brokerCode);
    setTimeout(() => {
      setIsCodeCopied(false);
    }, 3000);
  };

  return (
    <Nav
      className="nav-tabs-custom mb-3 ms-0  border-bottom-0 border-0"
      role="tablist"
    >
      <div className="d-flex align-items-center justify-content-start">
        <>
          <NavItem>
            <NavLink
              className={`text-primary  ${classnames({
                active: activeTab === "1",
                "fw-semibold": activeTab === "1",
              })}`}
              type="button"
              onClick={() => {
                tabChange("1");
              }}
            >
              DETAILS
            </NavLink>
          </NavItem>
          {!isUserInvited && (
            <NavItem>
              <NavLink
                className={`text-primary  ${classnames({
                  active: activeTab === "2",
                  "fw-semibold": activeTab === "2",
                })}`}
                onClick={() => {
                  tabChange("2");
                }}
                type="button"
              >
                CHANGE EMAIL
              </NavLink>
            </NavItem>
          )}
        </>

        <NavItem>
          <NavLink
            className={`text-primary  ${classnames({
              active: activeTab === "3",
              "fw-semibold": activeTab === "3",
            })}`}
            onClick={() => {
              tabChange("3");
            }}
            type="button"
          >
            CHANGE PASSWORD
          </NavLink>
        </NavItem>
      </div>

      {openModalInviteCode && (
        <InviteCodeModal
          open={openModalInviteCode}
          setOpen={setOpenModalInviteCode}
          onInviteCode={onInviteCode}
        />
      )}
    </Nav>
  );
};

export default NavProfile;
